import React from "react";
import SubjectIcon from "@material-ui/icons/Subject";
import { connect } from "react-redux";
import { setSelectedCard } from "../../store/actions/passiveIncomeActions";

const RightSidebar = ({
  setSelectedCard,
  selectedCard,
  opportunities,
}) => {
  const selectedOpportunity = opportunities?.find(
    (item) => item.id === selectedCard
  );

  return (
    <div id="rightSidebar">
      <div className="title-sidebar">
        <SubjectIcon /> Renda Passiva
      </div>
      <div>
        {selectedOpportunity && (
          <div className="sidebar-description">
            {selectedOpportunity.longDescription || "Descrição indisponível."}
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  selectedCard: state.opportunities.selectedCard, 
  opportunities: state.opportunities.opportunities,
});

export default connect(mapStateToProps, { setSelectedCard })(RightSidebar);
